import type { ViewType } from 'owa-calendar-actions';
import { respondToCalendarEvent } from 'owa-calendar-events-actions';
import { lazyOpenNotesEditor } from 'owa-calendar-notes-editor';
import type CalendarTime from 'owa-calendar-types/lib/types/CalendarTime';
import type { ClientItemId } from 'owa-client-ids';
import { ControlIcons } from 'owa-control-icons';
import type AttendeeType from 'owa-service/lib/contract/AttendeeType';
import type { BusyType } from 'owa-graph-schema';
import EventScope from 'owa-service/lib/contract/EventScope';
import type ResponseTypeType from 'owa-service/lib/contract/ResponseTypeType';
import { shouldShowDeclinedEvents } from 'owa-show-declined-meetings-user-config';
import EditorScenarios from 'owa-editor/lib/store/schema/EditorScenarios';
import CalendarReplyRegular from 'owa-fluent-icons-svg/lib/icons/CalendarReplyRegular';
import { isFeatureEnabled } from 'owa-feature-flags';

export function editResponseMessageHandler(
    calendarEventId: ClientItemId,
    currentResponseType: ResponseTypeType,
    currentFreeBusyType: BusyType,
    eventScope: EventScope,
    isRecurringItem: boolean,
    editorTitleText: string,
    actionSource: ViewType,
    selectedResponseType: ResponseTypeType,
    showNotifyToggle: boolean,
    proposeNewTime?: CalendarTime,
    meetingMessageId?: string,
    onSendHandler?: (
        eventScope: EventScope,
        responseText: string,
        proposedTime: CalendarTime,
        sendResponse: boolean,
        forwardees: AttendeeType[],
        timeOpen: number
    ) => void
) {
    const icon = isFeatureEnabled('mon-cal-showReadingPaneInCards')
        ? CalendarReplyRegular
        : ControlIcons.CalendarReply;

    lazyOpenNotesEditor.importAndExecute(calendarEventId.Id, {
        editorScenario: EditorScenarios.ItemPeekToRespond,
        eventScope: eventScope,
        onSend: (
            eventScope: EventScope,
            responseText: string,
            proposedTime: CalendarTime,
            sendResponse: boolean,
            forwardees: AttendeeType[],
            timeOpen: number
        ) => {
            respondToCalendarEvent(
                calendarEventId,
                currentResponseType,
                selectedResponseType,
                currentFreeBusyType,
                eventScope,
                sendResponse,
                actionSource,
                responseText,
                proposedTime,
                shouldShowDeclinedEvents() /* showingDeclinedEvents */,
                meetingMessageId
            );
            if (onSendHandler) {
                onSendHandler(
                    eventScope,
                    responseText,
                    proposedTime,
                    sendResponse,
                    forwardees,
                    timeOpen
                );
            }
        },
        titleText: editorTitleText,
        iconName: icon,
        showNotifyToggle: showNotifyToggle,
        sendResponse: showNotifyToggle || proposeNewTime != null,
        proposedTime: proposeNewTime,
        isDeclinedSeriesInstance:
            currentResponseType === 'Decline' &&
            isRecurringItem &&
            eventScope !== EventScope.AllInstancesInSeries,
        responseType: selectedResponseType,
    });
}
